module.exports = __webpack_public_path__ + "static/sec4-bg-f4b674255bfef32e197c056ac0df4dd2.jpg";